module.exports = __webpack_public_path__ + "img/plus-circle-fill.c531679f.svg";